<template>
  <div class="header-layout">
    <div class="logo-layout">
      <router-link :to="{name: 'home'}" class="logo">
        <vcenter>
          <img :src="language === 'en'?`${$cdn}images/logo-en.png`:`${$cdn}images/logo.png`" alt>
        </vcenter>
      </router-link>
    </div>
    <div class="menu">
      <div class="lang" :style="{maxWidth:isWide?'300px':'150px'}">
        <vcenter>
          <a :class="{active: language === 'en'}" @click="$store.commit('change_language', 'en')">En</a>
          <a :class="{active: language === '中'}" @click="$store.commit('change_language', '中')">中</a>
        </vcenter>
      </div>
      <div
        class="list"
        ref="list"
        @mouseleave="hoverCp !== 'isearch' && hoverCp !== 'ilogin' && hideCp()"
      >
        <a
          v-for="nav in langHeader.navs"
          :key="nav.text"
          @mouseenter="hoverCp !== 'isearch' && hoverCp !== 'ilogin' && showCp(nav.cp, 135)"
          @click="clickHandle(nav)"
          :class="{active: hoverCp === nav.cp}"
        >{{nav.text}}</a>

        <div class="child-layout" :style="{maxHeight: height + 'px'}" ref="navLayout">
          <i class="silp" :style="{left: split + 'px',height:hoverCp === 'isearch'?'auto':'100%'}"></i>
          <slot :cp="hoverCp"/>
        </div>
      </div>
    </div>
    <div class="ctrl">
      <a class="search" ref='isearchref' @click="searchHandle" :class="{active: hoverCp === 'isearch'}">
        <vcenter>
          <i class="iconfont icon-sousuo open"></i>
          <i class="iconfont icon-cuowu hide"></i>
        </vcenter>
      </a>
      <a class="user" v-if="!isLogin" @click="loginHandle">
        <vcenter>
          <i class="iconfont icon-geren"></i>
          <span>{{langHeader.login}}</span>
        </vcenter>
      </a>
      <a class="user cart" :style="{width:language==='en'?'273px':'192px'}" v-else>
        <div class="cart-user" @click="$router.push({name:deviceLogin?'scene':'information'})">
          <div class="user-img" :style="{background:info.head?`url(${info.head}) 50% 50%/cover no-repeat`:`#e6e6e6 50% 50%/cover no-repeat`}"></div>
          <ul class="user-hover">
            <li class="item" @click="$router.push({name:deviceLogin?'scene':'information'})">{{langHeader.myaccount}}</li>
            <li class="item" @click.stop="handleLogout">{{langHeader.logout}}</li>
          </ul>
        </div>
        <div class="cart-icon" @click="loginHandle('cart')">
          <i class="iconfont icon-cart"></i>
          <sup v-if="language!=='en'">{{count>99?'99+':count}}</sup>
          <span>{{langHeader.cart}}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import vcenter from '@/components/vcenter'
import { getPosition, isWide } from '@/util'

import browser from '@/util/browser'

export default {
  data () {
    return {
      height: 0,
      hoverCp: '',
      overb: false,
      active: true,
      ismobile: browser.mobile,
      browserLang: browser.language,
      isWide,
      count: 0
    }
  },
  methods: {
    clickHandle (nav) {
      if (nav.cp === 'case_overview') {
        this.$router.push({name: 'cases', params: {id: '房地产'}})
      } else if (nav.cp === 'service_overview') {
        this.$router.push({name: 'service_list', params: {id: 'use', active: 'pro'}})
      } else {
        this.$router.push({ name: nav.cp })
      }
    },
    handleLogout () {
      this.$toast.showConfirm('warn', this.language === 'en' ? 'Are you sure to log out?' : '确定要退出登录吗？', async () => {
        await this.$store.dispatch('logout')
        this.$router.push({name: 'home'})
      })
    },
    showCp (cp, height) {
      clearTimeout(this.timeout)
      if (cp !== 'about' && cp !== 'location') {
        this.$bus.$emit('showMask')
      }
      this.hoverCp = cp
      this.height = height
    },
    hideCp () {
      clearTimeout(this.timeout)
      this.$bus.$emit('hideMask')
      this.height = 0
      this.timeout = setTimeout(() => {
        this.hoverCp = null
      }, 200)
    },
    searchHandle () {
      if (this.hoverCp === 'isearch') {
        this.hideCp()
      } else {
        this.showCp('isearch', window.innerHeight - 68)
      }
    },
    loginHandle (type = null) {
      if (type === 'cart' && this.language === 'en') {
        return window.open('https://www.alibaba.com/product-detail/4DKanKan-Pro-3D-camera-3D-space_62183626283.html?spm=a2700.icbuShop.74.1.66b35b10I4miJd')
      }
      this.$bus.$emit('showAside')
    }
  },
  computed: {
    ...mapState({
      language: state => state.language.current,
      langHeader: state => state.language.home.headers,
      split: state => state.ui.navDivision,
      isLogin: state => state.user.token,
      info: state => state.user.info,
      deviceLogin: state => state.user.deviceLogin
    })
  },
  mounted () {
    let lang = ~this.browserLang.indexOf('zh') ? '中' : 'en'
    this.$store.commit('change_language', lang)
    if (this.isLogin && !this.deviceLogin) {
      let cart = JSON.parse(this.$store.state.user.cart)
      let count = 0
      cart.forEach(item => {
        count += item.goodsCount
      })
      this.count = count
    }
    this.$bus.$on('hadload', data => {
      this.$store.commit('change_nav_division', getPosition(this.$refs.list).x)
    })
    this.$bus.$on('updateCart', data => {
      this.count = data
    })
    this.$bus.$on('hideSearch', target => {
      if (this.$refs.isearchref) {
        if (!this.$refs.isearchref.contains(target)) {
          this.hideCp()
        }
      }
    })
    this.sizeHandle = () => {
      this.isWide = Math.round(devicePixelRatio * 100) === 100 ? window.innerWidth > 1600 : true
      this.$nextTick(() => {
        this.$store.commit('change_nav_division', getPosition(this.$refs.list).x)
      })
    }
    window.addEventListener('resize', this.sizeHandle)
    setTimeout(this.sizeHandle, 300)
  },
  destroyed () {
    window.removeEventListener('resize', this.sizeHandle)
  },
  components: { vcenter },
  watch: {
    language (newVal) {
      document.title = newVal === 'en' ? '4DKanKan' : '四维看看'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./istyle.scss";
</style>



// WEBPACK FOOTER //
// src/page/layout/header/index.vue